"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionHistoryTable = void 0;
const tslib_1 = require("tslib");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const modal_service_1 = require("../../components/modal/modal.service");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const spinner_1 = require("../../components/spinner/spinner");
const table_1 = require("../../components/table/table");
const table_style_1 = require("../../components/table/table.style");
const theme_1 = require("../../components/theme");
const theme_2 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const store_1 = require("../../store");
const classnames_1 = require("../../util/classnames");
const CSS = {
    container: 'c-CollectionHistoryTable',
    loading: 'c-CollectionHistoryTable--loading',
    tableCell: 'c-CollectionHistoryTable--tableCell',
    rowActions: 'c-CollectionHistoryTable--rowActions',
    revertButton: 'c-CollectionHistoryTable--revertButton',
    photoMeasure: 'c-CollectionHistoryTable--photoMeasure',
    titleBar: 'c-CollectionHistoryTable--titleBar',
    imageButton: 'c-CollectionHistoryTable--imageButton'
};
(0, theme_1.addStyles)({
    [`${CSS.container} .${table_style_1.CSS.container}`]: {
        width: '80%'
    },
    [`${CSS.container} .${table_style_1.CSS.cell}`]: {
        padding: '0px 18px'
    },
    [`${CSS.container} .${table_style_1.CSS.body} th:first-of-type`]: {
        width: '132px'
    },
    [`${CSS.container} .${table_style_1.CSS.body} td:first-of-type`]: {
        width: '132px'
    },
    [`${CSS.container} .${table_style_1.CSS.body} th:last-of-type`]: {
        width: '150px'
    },
    [`${CSS.container} .${table_style_1.CSS.body} td:last-of-type`]: {
        width: '150px'
    },
    [CSS.loading]: {
        display: 'flex',
        'justify-content': 'center'
    },
    [CSS.tableCell]: {
        'text-overflow': 'ellipsis',
        overflow: 'hidden',
        'white-space': 'nowrap'
    },
    [`${table_style_1.CSS.row}:hover .${CSS.rowActions}`]: {
        visibility: 'visible'
    },
    [CSS.rowActions]: {
        display: 'flex',
        'justify-content': 'flex-end',
        visibility: 'hidden'
    },
    [CSS.revertButton]: {
        'margin-top': theme_2.DefaultTheme.space(1)
    },
    [CSS.photoMeasure]: {
        transform: 'rotate(-90deg)'
    },
    [CSS.titleBar]: {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        width: '100%'
    },
    [CSS.imageButton]: {
        margin: theme_2.DefaultTheme.space(1)
    }
});
const header = [
    (0, i18n_1.Translate)(i18n_1.T.REVISION_ID),
    (0, i18n_1.Translate)(i18n_1.T.MODIFIED_AT),
    (0, i18n_1.Translate)(i18n_1.T.MODIFIED_BY),
    (0, i18n_1.Translate)(i18n_1.T.MODIFICATIONS),
    ''
];
const cellView = (children) => (0, mithril_1.m)('span', { title: typeof children === 'string' ? children : undefined, className: CSS.tableCell }, children);
const photoMeasureLinkButton = (departmentId, tagId, collectionId) => image_button_1.ImageButton.view(icons_1.MaterialIcon.PHOTO_MEASURE, {
    title: i18n_1.T.LINK_PHOTOMEASURE,
    className: (0, classnames_1.classNames)(CSS.photoMeasure, CSS.imageButton),
    href: page_1.IkePageName.collectionMeasure,
    hrefParams: {
        t: tagId,
        d: departmentId,
        collection: collectionId
    },
    disabled: false
});
const mapLinkButton = (tagId, collectionId) => image_button_1.ImageButton.view(icons_1.MaterialIcon.MAP, {
    title: i18n_1.T.LINK_MAP_WITH_COLLECTION,
    className: CSS.imageButton,
    href: page_1.IkePageName.map,
    hrefParams: {
        t: tagId,
        collection: collectionId
    },
    disabled: false
});
const linkButtons = (departmentId, tagId, collectionId) => (0, mithril_1.m)('div', [
    photoMeasureLinkButton(departmentId, tagId, collectionId),
    mapLinkButton(tagId, collectionId)
]);
exports.CollectionHistoryTable = {
    view: (collectionSummary, revisions, userNames, modificationMessages) => ((0, mithril_1.m)('div', { className: CSS.container }, [
        table_1.Table.view((0, mithril_1.m)('div', { className: CSS.titleBar }, [
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY_ID, collectionSummary.title),
            linkButtons(services_1.Services.Department.current.objectId, collectionSummary.tags[0], collectionSummary.uuid)
        ]), header, revisions.map((r, i) => {
            var _a, _b;
            return [
                cellView(r.revision),
                cellView(new Date(r.updatedAt).toUTCString()),
                cellView((_a = userNames === null || userNames === void 0 ? void 0 : userNames[r.updatedBy]) !== null && _a !== void 0 ? _a : spinner_1.Spinner.view()),
                cellView((_b = modificationMessages === null || modificationMessages === void 0 ? void 0 : modificationMessages[r.revision]) !== null && _b !== void 0 ? _b : spinner_1.Spinner.view()),
                (0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(CSS.tableCell, CSS.rowActions) }, i !== 0 ? (0, mithril_1.m)('button', {
                    className: 'mdl-button', onclick: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                        const modalResult = yield modal_service_1.ModalService.open({
                            title: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY_MODAL_TITLE, { collectionName: collectionSummary.title, revisionId: r.revision }),
                            content: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION),
                            hasCancel: true,
                            okName: i18n_1.T.COLLECTION_REVISION_HISTORY_MODAL_REVERT
                        });
                        // Revert the collection!
                        if (modalResult.ok && !modalResult.cancel) {
                            const result = yield services_1.Services.Department.rest.Collection.revert({ collectionUuid: collectionSummary.uuid, revisionIdToRevertTo: r.revision });
                            if (result.results.collection) {
                                notification_service_1.NotificationService.success({ key: i18n_1.T.COLLECTION_REVISION_HISTORY_MODAL_SUCCESS });
                                store_1.AppStore.TagSummary.clear();
                                services_1.Services.Route.go(page_1.IkePageName.collectionMeasure, {
                                    d: services_1.Services.Department.current.objectId,
                                    t: result.results.collection.jobuuid,
                                    collection: collectionSummary.uuid
                                });
                            }
                            else {
                                notification_service_1.NotificationService.error({ key: i18n_1.T.COLLECTION_REVISION_HISTORY_MODAL_FAILURE });
                            }
                        }
                    })
                }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY_MODAL_REVERT)) : undefined)
            ];
        }))
    ]))
};
//# sourceMappingURL=collection.history.table.js.map